import { DataRecord } from "../../chat/types";
import viagsApiDev from "../../chats/api/axiosClientdev";
import { CheckRequireSignDetailPayload, CreateRequireSignPayload, RequireSignStatus } from "../types";

export const hsmApi = {
  createRequireSign: async (body: CreateRequireSignPayload) => {
    try {
      const response = await viagsApiDev.post<DataRecord<string | null>>("/api/hsm/create-require-sign", body);

      return response.data;
    } catch (error) {
      throw error;
    }
  },

  checkRequireSignStatus: async (
    params: CheckRequireSignDetailPayload,
    config?: import("axios").AxiosRequestConfig,
  ) => {
    try {
      const response = await viagsApiDev.get<DataRecord<RequireSignStatus>>(
        `/api/hsm/check-require-sign-status/${params.requireSignId}`,
        config,
      );

      return response.data;
    } catch (error) {
      throw error;
    }
  },
};
